import React, { Suspense, lazy, useState } from 'react';
import HeroSection from '../components/HeroSection';
import StickyFooter from '../components/StickyFooter';
import StickyCTAs from '../components/StickyCTAs';

// Below-fold sections load as separate chunks so the hero form paints first.
const MostBookedPackages = lazy(() => import('../components/MostBookedPackages'));
const FAQSection = lazy(() => import('../components/FAQSection'));
const Footer = lazy(() => import('../components/Footer'));

const SectionPlaceholder = () => <div className="min-h-[320px]" aria-hidden="true" />;

const MinimalTemplate = () => {
    const [selectedPackage, setSelectedPackage] = useState(null);

    // Receives the full package object (title, catalogId, itemType) from
    // MostBookedPackages' "Book Now" click — HeroSection uses catalogId/
    // itemType to build the cart, not just the title.
    const handlePackageSelect = (pkg) => {
        setSelectedPackage(pkg);
    };

    return (
        <div className="min-h-screen bg-white overflow-x-hidden">
            <HeroSection selectedPackage={selectedPackage} />

            <Suspense fallback={<SectionPlaceholder />}>
                <div className="py-12 bg-gray-50">
                    <div className="max-w-7xl mx-auto px-4 text-center">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Featured Packages</h2>
                        <p className="text-gray-600 mb-8">Choose from our most popular health checkups.</p>
                    </div>
                    <MostBookedPackages onPackageSelect={handlePackageSelect} />
                </div>

                <FAQSection />
                <Footer />
            </Suspense>

            <StickyFooter />
            <StickyCTAs />
        </div>
    );
};

export default MinimalTemplate;
